import { Box, Typography } from '@mui/material';

export const PaperSubheader = (props: { title: string }) => {
  const { title } = props;
  return (
    <Box
      sx={(theme) => ({
        px: 2,
        py: 1,
        bgcolor: theme.palette.background.paper,
        color: theme.palette.text.secondary,
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightMedium,
      })}
    >
      <Typography variant="subtitle2" color="text.secondary">
        {title}
      </Typography>
    </Box>
  );
};
